import request from './request'
// 查询登录日志列表
const rootPath =
  process.env.NODE_ENV === "development"
    ? "/api"
    : "https://language.phenxie.com/api";
export function login(params) {
    return request({
      url: rootPath+'/user/login',
      method: 'post',
      data: params
    })
  }
export function getUserInfo(userId) {
    return request({
      url: rootPath+`/user/getUserInfo/${userId}`,
      method: 'get',
      data: {}
    })
  }
export function register(params) {
    return request({
      url: rootPath+'/user/register',
      method: 'post',
      data: params
    })
  }
export function settingName(params) {
    return request({
      url: rootPath+'/user/changeDoctorName',
      method: 'post',
      data: params
    })
  }
export function changePasswordRequest(params) {
    return request({
      url: rootPath+'/user/changePassword ',
      method: 'post',
      data: params
    })
  }